export default class redirectRule {
    from!: string;
    to!: string;
}
